var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0833 0.5H7.41667C6.70942 0.5 6.03115 0.780951 5.53105 1.28105C5.03095 1.78115 4.75 2.45942 4.75 3.16667V8.5H7.41667V3.16667H30.0833V21.8333H7.41667V16.5H4.75V21.8333C4.75 22.5406 5.03095 23.2189 5.53105 23.719C6.03115 24.219 6.70942 24.5 7.41667 24.5H30.0833C30.7906 24.5 31.4689 24.219 31.969 23.719C32.469 23.2189 32.75 22.5406 32.75 21.8333V3.16667C32.75 2.45942 32.469 1.78115 31.969 1.28105C31.4689 0.780951 30.7906 0.5 30.0833 0.5ZM10.0833 16.5V13.8333H0.75V11.1667H10.0833V8.5L15.4167 12.5L10.0833 16.5ZM27.4167 13.8333H18.0833V11.1667H27.4167V13.8333ZM27.4167 8.5H18.0833V5.83333H27.4167V8.5ZM23.4167 19.1667H18.0833V16.5H23.4167V19.1667Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenOrder);
export default __webpack_public_path__ + "static/media/openOrder.4aefae6e613d7e241cac3565f7e10610.svg";
export { ForwardRef as ReactComponent };